import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConfigService} from '@services/infra/config.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(
    private readonly http: HttpClient,
    private readonly conf: ConfigService,
  ) {}

  setSlug(companyId: string, slug: string | null): Observable<void> {
    const url = `${this.conf.backendUrl}/v1/company/${companyId}/slug`;
    return this.http.put<void>(url, {slug});
  }
}
